module.exports = __webpack_public_path__ + "img/solarcrest.b0d1161d.png";